const INITIAL_STATE = {
    data: null
}

const InspeccaoReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'inspeccao': {

            return {
                ...state,
                data: action.payload.inspeccao
            }
        }
        default: {
            return state
        }
    }
}

export default InspeccaoReducer